import request from '@/utils/request'
import axios from '@/utils/axios'
// 验证码
export function captcha() {
  return axios({
    url: '/auth/captcha',
    method: 'get'
  })
}

// export function login(data, header) {
//   return request({
//     url: '/passport/login',
//     method: 'post',
//     headers: header,
//     data
//   })
// }

// 登录
export function login(data, header) {
  return request({
    url: '/auth/login',
    method: 'post',
    headers: header,
    data
  })
}

export function refreshToken(data) {
  return request({
    url: '/passport/refresh-token',
    method: 'put',
    data
  })
}

export function logout(data) {
  return request({
    url: '/auth/login_out',
    method: 'post',
    data
  })
}

// 获取 Casdoor 管理员列表
export function getCasdoorAdminList(params) {
  return request({
    url: '/auth/casdoor/get_admin_list',
    method: 'get',
    params
  })
}

// 切换 Casdoor 管理员并获取 token
export function switchCasdoorAdmin(params) {
  return request({
    url: '/auth/casdoor/switch_admin_id',
    method: 'get',
    params
  })
}

